// Nest returns `message` as a string, or an array of strings for validation errors.
export function getApiErrorMessage(error: any, fallback: string): string {
  const message = error?.response?.data?.message;
  if (Array.isArray(message) && message.length) return message.join(', ');
  if (typeof message === 'string' && message) return message;
  return error?.message || fallback;
}
